import React from 'react';
import { connect } from 'react-redux';

// Components
import Anchor from 'Components/common/Anchor';
import BasicButton from 'Components/common/BasicButton';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import { openNotification } from 'Actions/notification';
import Header from 'Components/common/Header';
import SearchInput from 'Components/common/SearchInput';
import { Grid } from '@material-ui/core'

// Actions
import { getB2bPlatformList, updateB2bListSearchFields } from 'Actions/b2bManagement';
import { T } from 'Actions/translate';

// Icons
import { ArrowBackIos,KeyboardArrowRight } from '@material-ui/icons';

class B2bPlatformList extends React.Component {
    pager = {
        pageNum: 0,
        pageSize: 10,
        pageTotal: 9999999999999
    };
    state = {
        listLoaded: true,
        isBackupDialogOpened: false,
        currentId: 0
    };
    
  async componentDidMount(){
        window.scrollTo(0,0);
        const type = this.props.location.state && this.props.location.state.type
        if(type!=='list' || type==undefined){
        await this.props.updateB2bListSearchFields({
            queryKey: { $set: "" }
         });  
        }
        this.getList();
    }

    getList = (params,flag) => {
       const { queryKey } =this.props
        if(this.state.listLoaded === false) return;
        if(flag){
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
        this.setState({listLoaded: false});

        this.props.getB2bPlatformList({
            pageNum: params && params.queryKey.trim() ? 1 : (flag ? 1 : this.pager.pageNum + 1),
            pageSize: this.pager.pageSize,
            key: params && params.queryKey ? params.queryKey.trim() : queryKey.trim()
        }).then(res => {
            this.pager.pageNum = flag ? 1 :res.pageNum;
            this.pager.pageSize = res.pageSize;
            this.pager.pageTotal = res.pageTotal || 1;
            this.setState({ listLoaded: true });
        }).catch(res => {
            this.setState({ listLoaded: true });
        });
    }

    onChange = (title, value) =>{
		let searchParam = {
    		'queryKey': value
		}

		this.props.updateB2bListSearchFields({
			[title]: { $set: value }
		});
    }

    search = () => {
        let searchParam = {
            'queryKey': this.props.queryKey.trim()
        }

        if (!this.props.queryKey || !this.props.queryKey.trim()) {
            this.pager.pageNum = 1;
        }
        this.getList(searchParam,true)
    }

    gotoAddB2bPlatform = () => {
        this.props.history.push(`/addB2bPlatform`, { type: "add"});
    }

    b2bView = (item)=>{
        this.props.history.push(`/viewB2bPlatform/${ item.id }`, {id:item.id,item:item});
    }

    goBack = ()=>{
        this.props.history.push('/userCenter')
    }

    render() {
	    const { queryKey } = this.props;
        return (
            <div className="b2b-platform-list-container">
                <Header hasUserCenter={ true } hasArrowBackIos={ true } backEvent={this.goBack}>
                    <div className="header-search-input">
                       <h2 className="header-title">{ T('b2b_management_platform_list') }</h2>
                       <SearchInput title="queryKey" defaultValue={queryKey} value={ queryKey }  placeholder={ T('b2b_management_enter_st_or_subject') } search={ this.search } onChange={ this.onChange }></SearchInput>
                    </div>
                </Header>
                
                <ScrollWrapper listLoaded={ this.state.listLoaded } showAbyss={ this.pager.pageNum >= this.pager.pageTotal } showLoadingMore={ !this.state.listLoaded } getMoreData={this.getList }>
                    <ul className="b2b-platform-list">
                        {
                            this.props.b2bPlatformList.length > 0 && this.props.b2bPlatformList.map((item, index) => (
                                <li className="b2b-platform-item" key={index} onClick={()=>{this.b2bView(item)}}>
                                    <h5 className="platform-shipto-infor">{ item.platformName }</h5>
                                    <section className="b2b-platform-info">
                                        <div>
                                            <p className="row text-ellipsis"><label>{T('backup_supply_center')}:</label> { item.supplyCenterName }</p>
                                            <p className="row text-ellipsis"><label>{T('b2b_management_platform_list_shipTo')}:</label> { item.stNumber }</p>
                                            {item.platformStCode ? <p className="row text-ellipsis"><label>{T('platformShipto')}:</label> <label className="platform-st-code-content" title={item.platformStCode}>{item.platformStCode && item.platformStCode.length>22 ? item.platformStCode.substr(0,22) :item.platformStCode }</label></p> : null}
                                            <p className="row text-ellipsis"><label>{T('order_subject')}:</label> { item.stAlpha && item.stAlpha.length>22 ? item.stAlpha.substr(0,22) :item.stAlpha }</p>
                                            <p className="row text-ellipsis"><label>{T('b2b_management_platform_list_wop')}:</label> { item.enableWop === 'Y' ? T('b2b_management_use') : T('b2b_management_not_use') }</p>
                                        </div>
                                        <Grid className='b2b-platform-item-right-icon' item xs={1}>
                                            <Anchor>
                                                <KeyboardArrowRight/>
                                            </Anchor>
                                        </Grid>
                                    </section>                                   
                                </li>
                            ))
                        }
                    </ul>
                </ScrollWrapper>
                <div className="b2b-platform-list-footer-wrap">
                    <div className="b2b-platform-list-footer container-max-width is-fixed">
                        <BasicButton className="b2b-platform-btn" type="primary" onClickOfSingleTap={ this.gotoAddB2bPlatform }>{T('b2b_management_add')}</BasicButton>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
	const { userCenter, localData, b2bManagement } = state;
	return {
        backupList: userCenter.backupList,
        b2bPlatformList: b2bManagement.b2bPlatformList,
        queryKey: b2bManagement.searchfields.queryKey,
        localData
	};
};

const mapDispatchToProps = {
    openNotification,
    getB2bPlatformList,
    updateB2bListSearchFields

};

export default connect(mapStateToProps, mapDispatchToProps)(B2bPlatformList);
